import firebase from "firebase";

// Initialize Firebase
const config = {
	// BUENA
	apiKey: "AIzaSyCQyGjDm7Y1oLjI4sV9tgokO1tELh0QmBE",
	authDomain: "agrupaciones-8721b.firebaseapp.com",
	databaseURL: "https://agrupaciones-8721b.firebaseio.com",
	projectId: "agrupaciones-8721b",
	storageBucket: "agrupaciones-8721b.appspot.com",
	messagingSenderId: "403995218071"

	// TEST
	// apiKey: "AIzaSyAyg5I5__xD95i4ulzTqZe4HKJDirU7tNs",
	// authDomain: "agrbkp-a30e4.firebaseapp.com",
	// databaseURL: "https://agrbkp-a30e4.firebaseio.com",
	// projectId: "agrbkp-a30e4",
	// storageBucket: "",
	// messagingSenderId: "137761028156"
};

const fire = firebase.initializeApp(config);

export default fire;



// WEBPACK FOOTER //
// ./src/components/fire.js